module.exports = __webpack_public_path__ + "static/media/by default.92024e05.svg";